import React from 'react';

import { BannerWrapper } from '@/modules/CarsStock/components/common.styles';
import { useTypedSelector } from '@/store/store';
import { selectStockCarsBanner } from '@/store/reducers/banners';
import {
  getCarListView,
  getPage,
  getSelectedFilters,
} from '@/store/reducers/cars-stock';
import { getBannerPosition } from '@/modules/CarsStock/components/common.helpers';
import CarsStockBanner from '@/components/CarsStockBanner';

import { BannerProps } from './types';

function Banner({ position }: BannerProps) {
  const banner = useTypedSelector(selectStockCarsBanner);
  const page = useTypedSelector(getPage);
  const { selectedCars } = useTypedSelector(getSelectedFilters);
  const view = useTypedSelector(getCarListView);
  const bannerPosition = getBannerPosition(
    banner.desktop?.row ?? 1,
    banner.desktop?.size ?? 0
  );
  const bannerSize = banner.desktop?.size;

  if (
    !banner ||
    !banner.desktop ||
    view === 'landscape' ||
    page.currentPage !== 1 ||
    selectedCars.selectedBrands.length > 1 ||
    selectedCars.selectedModels.length > 1 ||
    bannerPosition !== position
  ) {
    return null;
  }

  return (
    <BannerWrapper
      isVertical={bannerSize === 1}
      isVerticalTwo={bannerSize === 2}
      isVerticalThree={bannerSize === 3}
      isHorizontal={bannerSize === 4}
    >
      <CarsStockBanner
        image={{
          desktop: { url: banner.desktop.image ?? '' },
          laptop: {
            url: banner.desktop.imageLaptop ?? banner.desktop.image ?? '',
          },
        }}
        url={banner.desktop.url}
        isNewTab={banner.desktop.isNewTab}
        isHorizontal={bannerSize === 4}
      />
    </BannerWrapper>
  );
}

export default Banner;
